function getTopicParticle(label) {
  const lastCharCode = label.charCodeAt(label.length - 1);
  const hangulStart = 0xac00;
  const hangulEnd = 0xd7a3;

  if (lastCharCode < hangulStart || lastCharCode > hangulEnd) {
    return '은';
  }

  return (lastCharCode - hangulStart) % 28 === 0 ? '는' : '은';
}

function AuthRequiredPanel({ pageLabel, onLogin }) {
  return (
    <section className="auth-required" aria-labelledby="auth-required-title">
      <span className="section-kicker">로그인 필요</span>
      <h1 id="auth-required-title">
        {pageLabel}
        {getTopicParticle(pageLabel)} 로그인 후 이용할 수 있습니다.
      </h1>
      <p>공개 메뉴는 그대로 둘러볼 수 있고, 개인화 기능만 인증 뒤에 열립니다.</p>
      <button className="primary-action" type="button" onClick={onLogin}>
        로그인 상태로 보기
      </button>
    </section>
  );
}

export default AuthRequiredPanel;
